import { useEffect, useState } from "react";
import { MotionConfig } from "framer-motion";
import { Signal, Wifi, BatteryFull } from "lucide-react";

export const SCREEN_W = 402;
export const SCREEN_H = 874;
const BEZEL = 16;
const BODY_W = SCREEN_W + BEZEL * 2;
const BODY_H = SCREEN_H + BEZEL * 2;

const calcScale = () => {
  const w = window.innerWidth;
  const h = window.innerHeight;
  return w >= 1024 ? Math.min(h * 0.76, BODY_H) / BODY_H : Math.min(w * 0.9, 410) / BODY_W;
};

const usePhoneScale = () => {
  const [s, setS] = useState(calcScale);
  useEffect(() => {
    const on = () => setS(calcScale());
    window.addEventListener("resize", on);
    return () => window.removeEventListener("resize", on);
  }, []);
  return s;
};

export const StatusBar = ({ light = false }) => (
  <div className={`absolute inset-x-0 top-0 z-40 flex h-[54px] items-center justify-between px-[34px] pt-1 text-[16px] font-semibold ${light ? "text-white" : "text-[#08090D]"}`}>
    <span>9:41</span>
    <span className="flex items-center gap-1.5" aria-hidden>
      <Signal size={17} />
      <Wifi size={17} />
      <BatteryFull size={22} />
    </span>
  </div>
);

export const IPhoneFrame = ({ children, testId, screenClassName = "", ...rest }) => {
  const s = usePhoneScale();
  return (
    <div className="relative shrink-0" style={{ width: BODY_W * s, height: BODY_H * s }} data-testid={testId} {...rest}>
      <div className="iphone" style={{ width: BODY_W, height: BODY_H, transform: `scale(${s})` }}>
        <span className="iphone-btn iphone-btn--action" aria-hidden />
        <span className="iphone-btn iphone-btn--vol-up" aria-hidden />
        <span className="iphone-btn iphone-btn--vol-down" aria-hidden />
        <span className="iphone-btn iphone-btn--side" aria-hidden />
        <span className="iphone-btn iphone-btn--camera" aria-hidden />
        <div className="iphone-body">
          <div className={`iphone-screen ${screenClassName}`} data-testid={testId ? `${testId}-screen` : undefined}>
            <MotionConfig transformPagePoint={(p) => ({ x: p.x / s, y: p.y / s })}>{children}</MotionConfig>
            <span className="iphone-island" aria-hidden />
          </div>
        </div>
      </div>
    </div>
  );
};
